import type { IconButtonProps } from "@ecco/ui/icon-button";
import { colors, sizes, space } from "@ecco/ui/tokens";

export const overlayControlButtonProps = {
    variant: "transparent",
    bg: "transparent",
    color: "white",
    backdropFilter: "blur(50px)",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
    aspectRatio: 1,
    height: [sizes.navBarCollapsedHeight, sizes.navBarCollapsedHeight, sizes.navBarCollapsedHeight],
} satisfies Partial<IconButtonProps>;

export const outsideControlButtonProps = {
    variant: "outline",
    bg: colors.white,
    color: colors.black,
    borderColor: colors.black,
    borderWidth: "1px",
    borderRadius: 0,
    aspectRatio: 1,
    height: "32px",
    width: "32px",
    minW: "32px",
    minH: "32px",
} satisfies Partial<IconButtonProps>;

export const getControlButtonFocusStyles = (isOutside: boolean) => ({
    _focus: {
        outline: "none",
        boxShadow: "none",
    },
    _focusVisible: {
        outline: "2px solid",
        outlineColor: isOutside ? colors.black : colors.white,
        outlineOffset: "2px",
        boxShadow: isOutside ? "none" : `0 0 0 2px ${colors.black}`,
    },
});

type HeroVideoControlsAppearance = "outside" | "overlay";

export const getControlsContainerProps = (
    appearance: HeroVideoControlsAppearance,
    isCarousel: boolean
) => {
    const isOutside = appearance === "outside";

    const base = {
        role: "group" as const,
        "aria-label": "Video controls",
        display: "flex" as const,
        flexDirection: "row" as const,
        alignItems: "center" as const,
        gap: isOutside ? space["0.4"] : "0.2",
        zIndex: 10,
        position: "absolute" as const,
        bottom: isOutside ? space["1.6"] : [3, 6],
        pointerEvents: "auto" as const,
    };

    if (isCarousel) {
        return {
            ...base,
            right: [undefined, "189px"],
            left: ["173px", "auto"],
        };
    }

    if (isOutside) {
        return {
            ...base,
            right: space["1.6"],
            left: "auto",
        };
    }

    return {
        ...base,
        right: [3, 6],
        left: "auto",
    };
};
